import Simple from './Simple'

export default Simple